let pending = null;
export const setJump = (j) => { pending = j; };
export const takeJump = (tab) => {
  if (!pending || pending.tab !== tab) return null;
  const j = pending; pending = null; return j;
};
